import { render, staticRenderFns } from "./AlterStandart.vue?vue&type=template&id=2c0e3fb2&"
import script from "./AlterStandart.vue?vue&type=script&lang=js&"
export * from "./AlterStandart.vue?vue&type=script&lang=js&"
import style0 from "./AlterStandart.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports